import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import sniffer from 'sniffer';
import { Icon, translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { Field, Form, reduxForm } from 'redux-form';
import { Spinner } from 'UI';
import { Flex, Button } from '@haldor/ui';
import { FlexibleTextArea } from 'UI/Inputs';

var MessageForm = /*#__PURE__*/function (_Component) {
  _inherits(MessageForm, _Component);

  var _super = _createSuper(MessageForm);

  function MessageForm(props) {
    var _this;

    _classCallCheck(this, MessageForm);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_setInput", function (element) {
      _this.input = element;
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      if (_this.input != null && !sniffer.isDevice) {
        ReactDOM.findDOMNode(_this.input).focus();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "submit", function (values) {
      return new Promise( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(resolve, reject) {
          var conversation, data;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return _this.setState({
                    hideInput: true
                  });

                case 2:
                  conversation = _this.props.conversation;
                  data = _objectSpread({}, values);
                  data.text = values.text + '';

                  if (conversation != null) {
                    data.conversationID = conversation.id;
                  }

                  data.parentId = null;
                  data.text = data.text.replace(/\n/g, "<br />");
                  _context.next = 10;
                  return _this.setState({
                    hideInput: false
                  });

                case 10:
                  if (_this.props.onSubmit) {
                    _this.props.onSubmit(data).then(function () {
                      resolve(1);

                      _this.props.reset();
                    });
                  } else {
                    setTimeout(function () {
                      _this.setState({
                        hideInput: false
                      });

                      resolve(1);

                      _this.props.reset();
                    }, 1000);
                  }

                case 11:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    });

    _defineProperty(_assertThisInitialized(_this), "onKeyDown", function (e) {
      if (sniffer.isDesktop && !e.shiftKey && e.keyCode == 13) {
        e.preventDefault();

        _this.props.submit();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "required", function (value) {
      if (typeof value !== 'undefined' && value !== '') {
        // Field passes validation, return a undefined error for this field
        // Rule: Not undefined and not an empty string
        return undefined;
      } // Field failed validation, return error for this field (String)


      return _this.props.translate('write-message');
    });

    _this.input = null;
    _this.state = {
      hideInput: false
    };
    return _this;
  }
  /* Utils */


  _createClass(MessageForm, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          handleSubmit = _this$props.handleSubmit,
          submitting = _this$props.submitting,
          valid = _this$props.valid;
      var placeHolderText = this.props.translate('write-message');

      if (this.props.conversation != null) {
        if (this.props.conversation.status.toUpperCase() == "ARCHIVED") {
          placeHolderText = this.props.translate('conversation-archived');
        }
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "conversation message-form"
      }, /*#__PURE__*/React.createElement(Form, {
        onSubmit: handleSubmit(this.submit),
        className: "form form-component"
      }, /*#__PURE__*/React.createElement(Flex, {
        center: true
      }, /*#__PURE__*/React.createElement("div", {
        className: "input-container"
      }, !this.state.hideInput ? /*#__PURE__*/React.createElement(Field, {
        component: FlexibleTextArea,
        type: "text",
        name: "text",
        placeholder: placeHolderText,
        validate: this.required,
        rows: 1,
        onKeyDown: this.onKeyDown,
        disabled: this.props.disabled,
        ref: this._setInput,
        withRef: true,
        forwardRef: true
      }) : null), /*#__PURE__*/React.createElement(Button, {
        disabled: submitting || !valid || this.props.disabled
      }, !submitting ? /*#__PURE__*/React.createElement(Icon, {
        name: "Send"
      }) : null, submitting ? /*#__PURE__*/React.createElement(Spinner, {
        center: true,
        small: true
      }) : null))));
    }
  }]);

  return MessageForm;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations)
  };
}

export default connect(mapStateToProps)(reduxForm({
  form: 'MessageForm',
  destroyOnUnmount: true
})(MessageForm));